import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProfileModel} from "../../../../models/profile.model";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {Router} from "@angular/router";
import {profile} from "../../core/shared.selectors";
import {CommonService} from "../../services/common.service";
import {roles} from "../../constants/common.constants";

interface ConfigModel {
  id: number,
  name: string,
  link: string
}

@Component({
  selector: 'app-side-nav-profile-menu',
  templateUrl: './side-nav-profile-menu.component.html',
  styleUrls: ['./side-nav-profile-menu.component.css']
})
export class SideNavProfileMenuComponent implements OnInit, OnDestroy {
  profile: ProfileModel;
  profileAvatar: string;
  isExpanded: boolean = false;
  config: ConfigModel[] = [];
  roleMap = {
    1: 'stanford-admin',
    2: 'organization-admin',
    3: 'coach',
    4: 'adult',
    5: 'participant'
  }
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    public commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.store.select(profile)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.profile = data;
        this.makeProfileImage(data?.firstName || '', data?.lastName || '');
      })

    this.config = [
      {
        id: 1,
        name: 'Notification Center',
        link: `/${this.roleMap[this.profile.role]}/notifications`
      },
      {
        id: 2,
        name: 'My Profile',
        link: `/${this.roleMap[this.profile.role]}/my-profile`
      },
      ...(this.profile?.role == roles.participant ? [
        {
          id: 3,
          name: 'My Groups',
          link: `/${this.roleMap[this.profile.role]}/my-groups`
        }
      ] : []),
      ...(this.profile.role == roles['adult'] || this.profile.role == roles['participant']) ?
        [] :
        [
          {
            id: 4,
            name: 'Invite',
            link: `/${this.roleMap[this.profile.role]}/invite`
          }
        ],
      {
        id: 5,
        name: 'Logout',
        link: ''
      }
    ]
  }

  makeProfileImage(firstName, lastName) {
    const firstNameFirstLetter = firstName?.substring(0, 1);
    const lastNameFirstLetter = lastName?.substring(0, 1);
    this.profileAvatar = `${firstNameFirstLetter}${lastNameFirstLetter}`
  }


  openProfileMenu() {
    this.isExpanded = true;
  }

  closeProfileMenu() {
    this.isExpanded = false;
  }

  eachProfileMenuOptionClick(data: any) {
    if (data.name == 'Logout') {
      this.commonService.logout();
    } else {
      this.commonService.sideNavCollapse.next(true);
      this.router.navigate([data.link]);
    }
    this.closeProfileMenu();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
